const getters = {
    sidebar: state => state.app.sidebar
}


export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js